const API_URL = `${process.env.REACT_APP_API_URL}`;

export const iniciarSesionService = async (usuario,contrasena) => {
    
    try {
        const respuesta = await fetch(API_URL + "login.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ usuario, contrasena }),
        });
        if (respuesta.ok) {
            return await respuesta.json();
        } else {
            const error = await respuesta.json();
            throw new Error(error.mensaje);
        }
    } catch (error) {
        throw new Error("Error al conectar con el servidor.");
    }
};